module.exports = __webpack_public_path__ + "media/images/plans/ceremony/estimate_2-512df6b97bd21c46983afe151f7a4b6f.jpg";